import { AfterContentInit, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { UsuarioService } from 'src/app/services/usuario.service';
import { Meses } from 'src/app/utils/meses';
import { EquipamentoService } from './../../services/equipamento.service';
import { OSService } from './../../services/os-service';
import { SCAMP_API } from 'src/environments/environment';

@Component({
  selector: 'app-historico-equipamento',
  templateUrl: './historico-equipamento.component.html',
  styleUrls: ['./historico-equipamento.component.scss']
})
export class HistoricoEquipamentoComponent implements OnInit, AfterContentInit {

  constructor(
    private equipamentoService: EquipamentoService,
    private osservice: OSService,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,

  ) { }

  meses = Meses.meses;
  anos = [(new Date().getFullYear() - 1), new Date().getFullYear()];

  selectionYear: number | null = null;
  selectionMonth: number | null = null;

  equipamentoSelected: any;
  resultadosPesquisa: any[];
  nenhumResultado = true;
  isProcessing = false;
  isGeneratingToExcel = false;

  shouldOpenModalPesquisa: boolean = null;
  shoulOpenModalDetalhesEquipamento: boolean = null;

  excelFileName: string = '';
  hrefExcelFile: string = '';

  public autorizacoes: UsuarioAutorizacoes;

  ngOnInit() {
  }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('historico-equipamento');
  }


  resetSearch() {
    (document.getElementById("identificador") as HTMLInputElement).value = '';
    this.resultadosPesquisa = [];
    this.nenhumResultado = true;
    this.equipamentoSelected = null;
    this.excelFileName = '';
    this.hrefExcelFile = '';
    this.isGeneratingToExcel = false;
  }

  reset() {
    this.resetSearch();
    this.selectionYear = null;
    this.selectionMonth = null;

  }

  openModalPesquisa() {
    this.shouldOpenModalPesquisa = !this.shouldOpenModalPesquisa;
  }

  openModalDetalhesEquipamento() {
    this.shoulOpenModalDetalhesEquipamento = !this.shoulOpenModalDetalhesEquipamento;

  }

  optionYear(ano: number) {
    if (ano != this.selectionYear) {
      this.selectionYear = ano;
    } else {
      this.selectionYear = null;
    }
    this.consultaOSs();
  }

  optionMonth(mes: number) {
    if (mes != this.selectionMonth) {
      this.selectionMonth = mes;
    } else {
      this.selectionMonth = null;
    }
    this.consultaOSs();
  }

  retreatYear() {

    if (this.anos[0] < (new Date().getFullYear() - 10)) {
      return;
    }

    this.selectionMonth = 0
    this.anos[0] = this.anos[0] - 2;
    this.anos[1] = this.anos[1] - 2;
  }

  forwardYear() {

    if (this.anos[1] == new Date().getFullYear()) {
      return;
    }

    this.selectionMonth = 0
    this.anos[0] = this.anos[0] + 2;
    this.anos[1] = this.anos[1] + 2;
  }


  getEquipamentoByIdentificador(identificador: string) {


    if (identificador === '') {
      return;
    }

    this.equipamentoService.getByIdOrNSerieSumary(identificador).subscribe(

      (response) => {

        if (response != null)
        {
          this.equipamentoSelected = response;
          this.consultaOSs();
        } else {
          this.toastr.warning(`Nenhum equipamento encontrado com o <b>identificador</b> informado.<br /><br />
          Tente novamente ou considere utilizar a pesquisa avançada << <i class='fa fa-search'></i> >>`, '', {timeOut: 7000});
        }
        
      }
    )

  }


  displayEquipamento(equipamento) {

    this.equipamentoSelected = equipamento;
    this.consultaOSs();
    (document.getElementById("identificador") as HTMLInputElement).value = '';
  }


  consultaOSs() {
    this.excelFileName = '';
    this.hrefExcelFile = '';

    this.osservice.consultarOSs({
      tipoDeData: 'EF',
      equipamentoId: this.equipamentoSelected.id,
      ano: this.selectionYear,
      mes: this.selectionMonth
    }).subscribe(response => {

      this.resultadosPesquisa = response;

      if (this.resultadosPesquisa.length === 0) {
        this.nenhumResultado = true;
      } else {
        this.nenhumResultado = false;
      }
      this.isProcessing = false;
    },
      (err: any) => {
        this.toastr.error(err, 'Ocorreu um erro ao tentar fazer a pesquisa');
        this.isProcessing = false;
        // this.reset();
      });
  }


  exportarToExcel() {

    this.isGeneratingToExcel = true;
    this.osservice.exportarToExcel({
      tipoDeData: 'EF',
      equipamentoId: this.equipamentoSelected.id,
      ano: this.selectionYear,
      mes: this.selectionMonth
    }).subscribe(
      (response) => {

        if (response.success === true) {

          if (response.nenhumResultado === false) {

            this.excelFileName = response.fileName;
            this.hrefExcelFile = `${SCAMP_API.pathDownloadExcel}/${response.fileName}`
          } else {
            this.toastr.warning(response.msgErro);
          }
        } else {
          this.toastr.error(response.msgErro);
        }

        this.isGeneratingToExcel = false;
      }

    )


  }



}
